// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2uV6R","disabled":"FileBtn_disabled__wvtA7","warn":"FileBtn_warn__3Ul2u","fade":"FileBtn_fade__2if2S"};